<template>
  <component :is="field.headingSize" :class="{ 'font-semibold -mb-4 leading-tight text-lg': field.headingSize === 'h2' }">
    {{ field.name }}
  </component>
</template>

<script setup lang="ts">
interface Props {
  settings: object
  parentField?: object
  field: object
}

defineProps<Props>()
</script>
